import { useMemo, useState } from 'react';
import { POPOVER_MENU_ITEMS } from '../../../constants';

const initialState = {
  user: {},
  anchorEl: null,
  actionType: null,
  isModalOpen: false,
  isPopoverOpen: false,
  isSimpleFormOpen: false,
  isCancelPopupOpen: false,
};

export function useFamilyCircle({
  getMenuItems,
  createdUser,
  clearRequests,
  handleTargetUserInvite,
}) {
  const [circleState, setCircleState] = useState(initialState);
  const { user, isPopoverOpen } = circleState;

  const handleOpenInvite = () => {
    handleTargetUserInvite();
    setCircleState({
      ...circleState,
      isPopoverOpen: false,
    });
  };

  const handleOpenChangeRole = () => {
    setCircleState({
      ...circleState,
      isSimpleFormOpen: true,
      actionType: POPOVER_MENU_ITEMS.CHANGE_ROLE,
      isPopoverOpen: false,
    });
  };

  const handleOpenRemoveMember = () => {
    setCircleState({
      ...circleState,
      isModalOpen: true,
      actionType: POPOVER_MENU_ITEMS.REMOVE_MEMBER,
      isPopoverOpen: false,
    });
  };

  const handleOpenCancelInvitation = () => {
    setCircleState({
      ...circleState,
      isCancelPopupOpen: true,
      actionType: POPOVER_MENU_ITEMS.CANCEL_PENDING_INVITATION,
      isPopoverOpen: false,
    });
  };

  const getItems = useMemo(() => {
    const { pending, isTargetUser } = user;

    if (isTargetUser) {
      const targetUserItems = createdUser
        ? POPOVER_MENU_ITEMS.INVITE_PATIENT
        : POPOVER_MENU_ITEMS.REINVITE_PATIENT;

      return getMenuItems({
        [targetUserItems]: handleOpenInvite,
      });
    }

    const familyMemberCircleMenuItems = {
      [POPOVER_MENU_ITEMS.CHANGE_ROLE]: handleOpenChangeRole,
      [POPOVER_MENU_ITEMS.REMOVE_MEMBER]: handleOpenRemoveMember,
    };

    const pendingFamilyMemberCircleMenuItems = {
      [POPOVER_MENU_ITEMS.CANCEL_PENDING_INVITATION]: handleOpenCancelInvitation,
    };

    const familyCircleItems = pending
      ? pendingFamilyMemberCircleMenuItems
      : familyMemberCircleMenuItems;

    return getMenuItems(familyCircleItems);
  }, [
    user,
    createdUser,
    handleOpenInvite,
    handleOpenChangeRole,
    handleOpenRemoveMember,
    handleOpenCancelInvitation,
  ]);

  const handleClearState = () => {
    clearRequests();

    setCircleState(initialState);
  };

  const handleOpenPopover = (e, member) => {
    e.preventDefault();
    e.stopPropagation();

    setCircleState({
      ...circleState,
      anchorEl: e.currentTarget,
      isPopoverOpen: !isPopoverOpen,
      user: member,
    });
  };

  const handleOpenSimpleFormPopup = () =>
    setCircleState({ ...circleState, isSimpleFormOpen: true });

  return {
    getItems,
    circleState,
    handleClearState,
    handleOpenPopover,
    handleOpenSimpleFormPopup,
  };
}



// WEBPACK FOOTER //
// ./src/components/CircleOfCare/utils/useFamilySircle.js